import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useScheduledActionInvoiceQuery } from '../../../../api/gql';
import { InvoiceInfoBox } from '../../../../modules/admin/invoice/InvoiceInfoBox';

type Props = {
  taskId: string;
} & PaperProps;

export const TaskIdInvoiceInfoBox = ({ taskId, ...rest }: Props) => {
  const { data, isLoading, isError } = useScheduledActionInvoiceQuery({
    id: taskId,
  });

  const invoice = useMemo(() => data?.scheduledAction.invoice, [data?.scheduledAction.invoice]);

  return <InvoiceInfoBox invoice={invoice} isLoading={isLoading} isError={isError} {...rest} />;
};
